import DetailComponent from "./detail";
import { useParams } from "react-router-dom";
import listsFile from "@/static-texts/lists.json";
function Detail() {
  const { partners } = listsFile;
  const { id } = useParams();
  const { name, content, mainContent, imageSamll, link } = partners.find(
    ({ name }) => name === id
  );
  return (
    <DetailComponent
      title={name}
      content={content}
      mainContent={mainContent}
      image={imageSamll}
      link={link}
    />
  );
}
export default Detail;
